

    
<template>
  <v-dialog v-model="showModal" max-width="500px" 
      persistent
  >
    <v-card >
      <v-card-title> {{ title }} </v-card-title>
      <v-card-text>
        <div> 
        </div>
        <v-progress-linear
      :value="percentValue" 
     
        ></v-progress-linear>
        <p>{{ description }}</p>
        
      </v-card-text> 
    </v-card>
  </v-dialog>
</template>


 <style lang="">
</style> 
<script>
export default {
  data: () => ({ 
    showModal: false,  
    title: "",
    description: "",
    progress:0,
    count:0, 
  }), 
  watch:{

  },
  computed:{
    percentValue()
    {
      return (100/this.count)*this.progress;
    }
  },
  methods: { 
    
    Show(title,description,progress,count) { 
      this.title = title; 
      this.description = description;
      this.progress = progress;
      this.count = count;
      this.showModal = true; 
    },
     Hide(){
      this.showModal =false; 
      this.title = ""; 
      this.description = ""; 
      this.progress = 0;
      this.count = 0;
     }
  },
};
</script>

